export default __webpack_public_path__ + "static/media/add_circle_black_24dp.92dcd912.svg";